import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        selectionList({commit, dispatch, rootState}, filter) {
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/beauty-manager/services/selection-list',
                    { params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        fetch({commit, dispatch, rootState}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/beauty-manager/services/list',
                { params: filter }
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        add({commit, dispatch}, data) {
            return axios.post(
                '/api/beauty-manager/services/add',
                prepareData(data)
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return axios.post(
                '/api/beauty-manager/services/edit/' + editedItem.id,
                // editedItem
                prepareData(editedItem)
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({commit, dispatch}, itemId) {
            return axios.delete(
                '/api/beauty-manager/services/dell/' + itemId
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('beauty_salon_id', data.beauty_salon_id)
    fd.append('category_id', data.category_id)
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    if (data.prices) {
        const prices = data.prices.map((item) => {
            item.value = Number(item.value)
            return item
        })
        fd.append('prices', JSON.stringify(prices))
    }
    if (data.description) {
        fd.append('description', data.description)
    }

    if (data.price_value) {
        fd.append('price_value', data.price_value)
    }
    fd.append('published', Number(data.published))

    return fd
}
